import { render, staticRenderFns } from "./Minuses.vue?vue&type=template&id=aa19e3e6&"
import script from "./Minuses.vue?vue&type=script&lang=js&"
export * from "./Minuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports